export default {"src":"/_next/static/media/google-drive.bac6c92e.svg","height":513,"width":513};